import { combineReducers, Reducer } from 'redux'

// core
import config, { configActions } from './core/config.store'
import route, { routeActions } from './core/route.store'
import auth, { authActions } from './core/auth.store'
import user, { userActions } from './core/user.store'
import i18n, { i18nActions } from './core/i18n.store'
import main, { mainActions } from './core/main.store'
import grid, { gridActions } from './core/grid.store'
import department, { departmentActions } from './core/department.store'
import masterdata, { masterdataActions } from './core/masterdata.store'

// admin
import admin, { adminActions } from './admin/admin.store'
import adminUsers, { adminUsersActions } from './admin/adminUsers.store'
import accessControl, { accessControlActions } from './admin/accessControl.store'

// home
import customerAuth, { customerAuthActions } from './home/customerAuth.store'

const appReducer: Reducer = combineReducers({
	// core
	config,
	route,
	auth,
	user,
	i18n,
	main,
	grid,
	department,
	masterdata,

	// admin
	admin,
	adminUsers,
	accessControl,

	// home
	customerAuth,
})

export default appReducer

export {
	// core
	configActions,
	routeActions,
	authActions,
	userActions,
	i18nActions,
	mainActions,
	gridActions,
	departmentActions,
	masterdataActions,

	// admin
	adminActions,
	accessControlActions,
	adminUsersActions,

	// home
	customerAuthActions,
}
